import React from "react";
import clsx from "clsx";
import styles from "./Price.module.css";
import { formatPrice } from "../../utils/priceHelpers";
import { useViewModel } from "../../hooks/useViewModel";

interface PriceProps {
	price: number;
	isClubPrice?: boolean;
	currency?: string;
	size?: "small" | "medium" | "large";
	savings?: number;
	monthly?: string;
	listPrice?: number;
	locale?: string;
}

const Price: React.FC<PriceProps> = ({
	price,
	isClubPrice = false,
	size = "medium",
	savings,
	monthly,
	listPrice,
	locale = "nb-NO",
}) => {
	const formattedAmount = formatPrice(price, locale);

	const { data } = useViewModel();
	const { strings, isB2B } = data!;

	return (
		<div className={styles.gridPriceContainer}>
			<div className={styles.priceRow}>
				<span className={`${styles.price} ${styles[size]}`}>
					{formattedAmount},-
				</span>
				{listPrice && savings != null && (savings > 0) && (
					<div className={styles.savingsGroup}>
						<span className={clsx(styles.savings, isClubPrice && styles.savingsClub)}>
							{strings.product.configBundles.priceSaved.replace(
								"{VALUE}",
								String(formatPrice(savings, locale)),
							)}
						</span>
						<span className={styles.currentPrice}>
							{strings.product.configBundles.priceFrom.replace(
								"{VALUE}",
								String(formatPrice(listPrice, locale)),
							)}
						</span>
					</div>
				)}
			</div>
			{isB2B && (
				<span className={styles.exclVat}>
					{strings.product.configBundles.exclVatLabel}
				</span>
			)}
			{monthly && (
				<span className={styles.monthly}>
					<span className={styles.flex}>FLEX</span> {monthly}!
				</span>
			)}
		</div>
	);
};

export default Price;